// extracted by mini-css-extract-plugin
export default {"PostCreate":"qh_a bhn_qt bhn_a bhn_w bhn_ea"};